
import TimePicker from "@/components/TimePicker.vue";
import { DiagramData } from "@/types/diagram";
import { computed, defineComponent, PropType, ref, watch } from "vue";
import { useStore } from "@/store";
import { stationId } from "@/types";
import { formatDdHhmmToHhmm } from "@/logics/diagram";
import rfdc from "rfdc";
import { DATE_FORMAT } from "@/common/const";
import dayjs from "dayjs";

const clonedeep = rfdc();

export default defineComponent({
  components: {
    TimePicker,
  },
  props: {
    modelValue: { type: Object as PropType<DiagramData[]>, required: true },
  },
  emits: ["update:modelValue"],
  setup(props, context) {
    const store = useStore();
    const getStationName = computed(
      () => (id: stationId) => store.getters.getStation(id)?.name
    );

    const copy = ref(clonedeep(props.modelValue));
    const checkBoxesForDelete = ref<boolean[]>(
      props.modelValue.map(() => false)
    );
    watch(
      () => props.modelValue,
      () => {
        copy.value = clonedeep(props.modelValue);
      }
    );
    const onCellEditComplete = (e: { data: DiagramData; index: number }) => {
      const from = dayjs(props.modelValue[e.index].time, DATE_FORMAT);
      const to = dayjs(e.data.time, DATE_FORMAT);
      const offset = to.diff(from, "minutes");
      copy.value.forEach((v, idx) => {
        if (idx <= e.index) return;
        v.time = dayjs(v.time, DATE_FORMAT)
          .add(offset, "minutes")
          .format(DATE_FORMAT);
      });
      context.emit("update:modelValue", copy.value);
    };
    const onChangeCheckbox = (index: number, value: boolean) => {
      if (value) {
        let hasTrue = false;
        for (let i = 0; i < checkBoxesForDelete.value.length; i++) {
          if (i === index) {
            checkBoxesForDelete.value[i] = value;
            break;
          } else {
            if (!hasTrue && checkBoxesForDelete.value[i]) {
              hasTrue = true;
            }
            if (hasTrue) {
              checkBoxesForDelete.value[i] = value;
            }
          }
        }
      } else {
        for (let i = index; i < checkBoxesForDelete.value.length; i++) {
          if (i > index && !checkBoxesForDelete.value[i]) {
            break;
          }
          checkBoxesForDelete.value[i] = value;
        }
      }
    };
    const resetCheckbox = () => {
      checkBoxesForDelete.value = props.modelValue.map(() => false);
    };
    const deleteTime = () => {
      context.emit(
        "update:modelValue",
        copy.value.filter((v, i) => !checkBoxesForDelete.value[i])
      );
      resetCheckbox();
    };
    const rowClass = (data: DiagramData) => {
      if (data.stationId === store.state.stationList.startingStationId) {
        return "bg-cyan-50";
      }
      if (data.stationId === store.state.stationList.endingStationId) {
        return "bg-orange-50";
      }
      return null;
    };
    return {
      getStationName,
      formatDdHhmmToHhmm,
      copy,
      onCellEditComplete,
      checkBoxesForDelete,
      onChangeCheckbox,
      deleteTime,
      rowClass,
    };
  },
});
